import React from "react";
import "./Dictionary.css";
import Synonyms from "./Synonyms";

export default function Meaning(props) {
  return (
    <div>
      <h3 className="headings">{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index} className="info">
            <p>
              <p className="info-definition">{definition.definition}</p>
              <br />
              <p className="info-example">{definition.example}</p>
            </p>
            <br />
            <Synonyms synonyms={definition.synonyms} />
            <br />
          </div>
        );
      })}
      <div className="info">
        <p className="info-definition">
          {props.meaning.definitions[0].definition}
        </p>
        <p className="info-example">{props.meaning.definitions[0].example}</p>
      </div>
    </div>
  );
}
